export default __webpack_public_path__ + "images/3739262ffff39c127ac9b45de4209fe2-republican_party_small.webp";